import { render, staticRenderFns } from "./AccountServiceBalances.vue?vue&type=template&id=30e1bfba"
import script from "./AccountServiceBalances.vue?vue&type=script&lang=js"
export * from "./AccountServiceBalances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports